import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { Shipment } from 'Api/CoreApi';
import ApiProvider from 'Api/ApiProvider';
import { groupBy, forEach } from "lodash-es";
import { Dictionary } from 'vuex';

@Component({})
export default class ShipmentsComponent extends ABaseComponent {

    shipments: Shipment[] = [];
    filteredShipmentsByLocations: Dictionary<Shipment[]> = {};
    shipmentsByLocations: Dictionary<Shipment[]> = {};

    search: string = '';

    searchTimeout: number = 0;

    @Prop({default: 'LANG1'})
    languageId: string;

    @Watch('search')
    async onSearchChanged() {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            let filteredShipmentsByLocations: Dictionary<Shipment[]> = { };

            forEach(this.shipmentsByLocations, (shipments, key) => {
                let filteredShipments = shipments.filter(shipment => 
                    shipment.shipmentNumber.toUpperCase().includes(this.search.toUpperCase()) || 
                    shipment.locationName.toUpperCase().includes(this.search.toUpperCase()) ||
                    shipment.salesMainDepartment.toUpperCase().includes(this.search.toUpperCase())
                );
                

                if (filteredShipments.length > 0) {
                    filteredShipmentsByLocations[key] = filteredShipments;
                }
            });

            this.filteredShipmentsByLocations = filteredShipmentsByLocations;            
        }, 500);
    }

    async created() {
        await this.load();
    }

    async load() {
        this.setLoading();
        try {
            let client = ApiProvider.getApiClient();
            let shipmentsResult = await client.getShipments(this.search, this.languageId);

            this.shipments = shipmentsResult;

            this.shipmentsByLocations = groupBy(
                shipmentsResult
                , (shipment) => {
                    return shipment.customerName;
                }
            );

            this.filteredShipmentsByLocations = this.shipmentsByLocations;

            this.setLoaded();
        } catch (e) {
            this.setError(e);
        }
    }

}

Vue.component('shipments', ShipmentsComponent);
